import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { Box, Snackbar, Alert, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, register } from '../Redux/Auth/Action';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const SignUp = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const jwt = localStorage.getItem("jwt");

    useEffect(() => {
        if (jwt) {
            dispatch(getUser(jwt))
        }

    }, [jwt])
    const { auth } = useSelector((store) => store);

    if (auth.user) {
        navigate('/home')
    }

    const handleClose = () => setOpenSnackBar(false);

    // Effect to show Snackbar if there's a success or error message
    useEffect(() => {
        if (auth.user || auth.error) setOpenSnackBar(true);
    }, [auth.user, auth.error]);

    // Handle Form Submit
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const userData = {
            firstName: data.get('firstName'),
            lastName: data.get('lastName'),
            email: data.get('email'),
            password: data.get('password'),
            confirmPassword: data.get('confirm-password')
        };

        // Dispatch the register action
        dispatch(register(userData));
    };

    return (
        <>
            <Navbar />
            <div className='flex flex-col justify-center items-center h-fit bg-black text-gray-200 pt-32 pb-5'>
                <div className="w-full max-w-sm p-6 bg-[#1a1a1a] rounded-lg border border-gray-600">
                    <button
                        onClick={() => window.history.back()}
                        className="text-gray-400 border border-gray-400 py-2 px-4 rounded-lg mb-6 hover:bg-[#333] transition text-sm">
                        ← Back
                    </button>
                    <h1 className="text-3xl font-semibold text-white mb-4">Join Now</h1>
                    <p className="text-gray-400 mb-6">
                        Already have an account?{' '}
                        <a href="/login" className="text-white underline hover:text-gray-300 transition">
                            Sign in
                        </a>
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label htmlFor="firstName" className="block text-sm font-medium mb-1 text-gray-300">
                                First Name*
                            </label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                placeholder="John"
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="lastName" className="block text-sm font-medium mb-1 text-gray-300">
                                Last Name*
                            </label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                placeholder="Doe"
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="email" className="block text-sm font-medium mb-1 text-gray-300">
                                Email*
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="JohnDoe@gmail.com"
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                        </div>

                        <div className="mb-4 relative">
                            <label htmlFor="password" className="block text-sm font-medium mb-1 text-gray-300">
                                Password*
                            </label>
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                id="password"
                                name="password"
                                placeholder="Your Password"
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                            <span
                                onClick={() => setPasswordVisible(!passwordVisible)}
                                className="absolute right-3 top-8 cursor-pointer text-gray-400"
                            >
                                {passwordVisible ? '🙈' : '👁'}
                            </span>
                        </div>

                        <div className="mb-4 relative">
                            <label htmlFor="confirm-password" className="block text-sm font-medium mb-1 text-gray-300">
                                Confirm Password*
                            </label>
                            <input
                                type={confirmPasswordVisible ? 'text' : 'password'}
                                id="confirm-password"
                                name="confirm-password"
                                placeholder="Your Password"
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                            <span
                                onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                className="absolute right-3 top-8 cursor-pointer text-gray-400"
                            >
                                {confirmPasswordVisible ? '🙈' : '👁'}
                            </span>
                        </div>

                        <p className="text-gray-500 text-xs text-center mb-1">
                            Fields marked with * are required
                        </p>

                        <button
                            type="submit"
                            className="w-full py-2 bg-white text-black rounded-md hover:bg-gray-200 transition"
                        >
                            Sign Up
                        </button>
                    </form>
                </div>

                <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={auth.error ? 'error' : 'success'} sx={{ width: '100%' }}>
                        {auth.error ? auth.error : auth.user ? 'Register Success' : ''}
                    </Alert>
                </Snackbar>
            </div>
            <Footer />
        </>
    );
};

export default SignUp;
